import { call, put, takeEvery } from "redux-saga/effects";
import {
    GET_PROVISION_STATUS_DEF,
} from "./actionTypes"

import {
    getProvisionStatusDefListSuccess,
    provisionStatusDefApiError
} from "./actions"

//Include Both Helper File with needed methods
import {
    GetAllProvisionStatusDef,
} from "../../helpers/backend_helper/backend_helper"

function* onGetProvisionStatusDefList() {
  try {
    const response = yield call(GetAllProvisionStatusDef)
    yield put(getProvisionStatusDefListSuccess(response))
  } catch (error) {
    yield put(provisionStatusDefApiError(error))
  }
}

function* provisionStatusDefSaga() {
    yield takeEvery(GET_PROVISION_STATUS_DEF, onGetProvisionStatusDefList)
}

export default provisionStatusDefSaga